export default __webpack_public_path__ + "static/media/badge-icon-header.d678283d.svg";